import { render, staticRenderFns } from "./RevenueSummary.vue?vue&type=template&id=2d1e43a8&scoped=true"
import script from "./RevenueSummary.vue?vue&type=script&lang=js"
export * from "./RevenueSummary.vue?vue&type=script&lang=js"
import style0 from "./RevenueSummary.vue?vue&type=style&index=0&id=2d1e43a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1e43a8",
  null
  
)

export default component.exports